__turbopack_context__.v({
  "notStartedContainer": "GxHkZG_notStartedContainer",
  "notStartedText": "GxHkZG_notStartedText",
  "playBtnWrapper": "GxHkZG_playBtnWrapper",
});
